import { omit, omitBy } from 'lodash';
import { useMutation } from 'react-query';

import { API_CTX } from '@/config';
import { AuthUser } from '@/features/auth';
import { restoreURL } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

export type UpdateUserDTO = {
  /** user id */
  id?: string;
  /** user payload to update */
  data: Partial<AuthUser & { password: string }>;
};

export const updateUser = ({ id, data }: UpdateUserDTO) => {
  return restoreURL().patch(`${API_CTX}/users/${id}`, data);
};

type UseUpdateUserOptions = {
  userId?: string;
  onSuccess?: (...args: any[]) => void;
  config?: MutationConfig<typeof updateUser>;
};

export const useUpdateUser = ({
  userId,
  config,
  onSuccess,
}: UseUpdateUserOptions) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
      if (onSuccess) {
        onSuccess?.();
      } else {
        addNotification({
          type: 'success',
          title: 'User Updated',
        });
      }
    },
    ...config,
    mutationFn: (params) => {
      const data = omitBy(params.data, (v) => v === '');

      return updateUser({ id: userId || params.id, data });
    },
  });
};
